import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import CreateGameSchedule from './CreateGameSchedule/component';
import { IAppState } from '../../../state/reducers';
import { clearAll } from '../../../state/exchange/createGameScheduleDialog';

class CreateGameScheduleDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      onClose,
      isCreating,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={() => {
          if (!isCreating) onClose();
        }}
        fullWidth
        maxWidth="md"
      >
        <CreateGameSchedule />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.createGameScheduleDialog.isOpen,
  isCreating: state.exchange.createGameScheduleDialog.isCreating,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateGameScheduleDialog);
